 document.addEventListener('DOMContentLoaded', function () {
    const detailsElements = document.querySelectorAll('ul.list-menu.list-menu--inline>li>header-menu>details');

   console.log(detailsElements)

    detailsElements.forEach((details) => {
      const summary = details.querySelector('summary');
      const content = details.querySelector('.header__submenu');

      console.log(summary)
      console.log(content);
      let isHovering = false;
      let timeout;

      const openMenu = () => {
        clearTimeout(timeout);
        details.setAttribute('open', '');
        isHovering = true;
      };

      const closeMenu = () => {
        timeout = setTimeout(() => {
          if (!isHovering) {
            details.removeAttribute('open');
          }
        }, 100); // delay suave para evitar "piscar"
      };

      summary.addEventListener('mouseenter', openMenu);
      summary.addEventListener('mouseleave', () => {
        isHovering = false;
        closeMenu();
      });

      content?.addEventListener('mouseenter', () => {
        isHovering = true;
        openMenu();
      });

      content?.addEventListener('mouseleave', () => {
        isHovering = false;
        closeMenu();
      });

      summary.addEventListener('click', (e) => {
        e.preventDefault();
      });
    });
  });